module.exports = __webpack_public_path__ + "img/aio-marque.10839f48.png";